import './style.css'
type Status = 'searching' | 'thinking' | 'done'
interface Props {
  currentStatus: Status
}

const ThinkLoading = (props: Props) => {
  //  状态映射表
  const statusTextMap: Record<Status, string> = {
    searching: '正在搜索中',
    thinking: '正在思考中',
    done: '',
  }
  return (
    <>
      <div className="loadingContainer">
        <div className="chaotic-orbit"></div>
        <div className="shimmer-box">{statusTextMap[props.currentStatus]}</div>
      </div>
    </>
  )
}
export default ThinkLoading
